import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { homeBlogQueryOptions, homeCouponsQueryOptions, homeOffersQueryOptions } from "@/lib/homeQueries";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  // Cupons e blog chegam prontos no HTML do servidor (visíveis ao Google).
  loader: async ({ context }) => {
    await Promise.allSettled([
      context.queryClient.ensureQueryData(homeCouponsQueryOptions()),
      context.queryClient.ensureQueryData(homeOffersQueryOptions()),
      context.queryClient.ensureQueryData(homeBlogQueryOptions()),
    ]);
  },
  head: () => seoHead({
    title: "Shopping do Bem | Plataforma de Cashback Solidário",
    description: "Ajude projetos sociais através do Shopping do Bem. O Cashback solidário garante que toda compra vire doação.",
    path: "/",
  }),
  component: Index,
});
